import React from "react";
import { sortDate, sortNumber, sortString } from "../Components/SortFunctions";

export default function OpenVpnStats(props) {

    const tableTheme = props.theme;
    const tableClassName = `table table-striped table-hover table-${tableTheme}`;

    const noDataDiv = <div className={tableClassName}>
        <div className="alert alert-warning m-4">Waiting for data..</div>
    </div>;

    const [columns, setColumns] = React.useState([]);
    const [tableHeader, setTableHeader] = React.useState([]);

    function getColumnsName() {
        if (!columns.length) {
            let tmp = [];

            if (props?.OpenVpnStats?.client_list && props.OpenVpnStats?.routing_table) {
                Object.keys(props.OpenVpnStats.client_list[0]).forEach((key) => {
                    tmp.push(key);
                });

                Object.keys(props.OpenVpnStats.routing_table[0]).forEach((key) => {
                    if (!tmp.includes(key)) {
                        tmp.push(key);
                    }
                });
                setColumns(tmp);
            }
        }
    }

    function sortBy(column) {
        if (props.setSortCallback) {
            props.setSortCallback({ column: column });
        }
    }

    function getTableHeader() {
        if (!tableHeader.length && columns.length) {
            const tmp = columns.map((column) => {
                const key = `header_${column}`;
                const headerName = column.replace(/_/g, ' ');
                return (
                    <th
                        key={key}

                    >
                        {String(headerName[0]).toUpperCase() + String(headerName).slice(1)}
                        <button
                            key={column}
                            id={column}
                            name={column}
                            className="btn btn-secondary btn-sm mx-2"
                            onClick={() => sortBy(column)}
                        >
                            <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.5" d="M16 18L16 6M16 6L20 10.125M16 6L12 10.125" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M8 6L8 18M8 18L12 13.875M8 18L4 13.875" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </th>
                );
            });
            setTableHeader(tmp);
        }
    };


    function getColumn(client, index) {
        const col = columns.map((column, index) => {
            const key = `column_${index}`;

            let value = client[column];

            if (column === 'bytes_received' || column === 'bytes_sent') {
                value = Number(client[column])

                if (value > 1024 * 1024 * 1024) {
                    value = (value / 1024 / 1024 / 1024).toFixed(2) + ' G';
                } else if (value > 1024 * 1024) {
                    value = value / 1024 / 1024;
                    value = value.toFixed(2);
                    value += ' M';
                } else if (value > 1024 * 10) {
                    value = (value / 1024).toFixed(2) + ' K';
                }
            }

            return (
                <td key={key}>{value}</td>
            );
        });

        return col;
    }

    function getContent() {
        let data = [];

        if (props?.OpenVpnStats?.client_list?.length && props?.OpenVpnStats?.routing_table?.length) {
            data = props?.OpenVpnStats?.routing_table.map((client, index) => {

                let client_name = client.common_name;
                let client_data = {
                        common_name: "",
                        real_address: "",
                        connected_since: "",
                        bytes_received: "",
                        bytes_sent: "",
                }
                props?.OpenVpnStats?.client_list.forEach((element, index) => {
                    if(element.common_name === client_name) {
                        client_data = element
                    }
                })

                return {
                    ...props?.OpenVpnStats.routing_table[index],
                    ...client_data
                }
            });
        }

        if (!data || !data.length) {
            return null;
        }

        if (props?.sort?.column && props?.sort?.direction) {
            data.sort((a, b) => {
                if (props.sort.column === 'bytes_received' || props.sort.column === 'bytes_sent') {
                    return sortNumber(a, b, props.sort.column, props.sort.direction);
                } else if (props.sort.column === 'connected_since' || props.sort.column === 'last_ref') {
                    return sortDate(a, b, props.sort.column, props.sort.direction);
                } else {
                    return sortString(a, b, props.sort.column, props.sort.direction);
                }
            });
        }

        const rows = data.map((client, index) => {
            const columnData = getColumn(client);

            return (
                <tr key={`client_${index}`}>{columnData}</tr>
            );
        });

        return rows;
    };

    function socketState(state) {

        let text = null;
        let cl = 'mx-2 badge';

        switch (state) {
            case 0:
                text = 'CONNECTING';
                cl += ' bg-warning';
                break;
            case 1:
                text = 'OPEN';
                cl += ' bg-success';
                break;
            case 2:
                text = 'CLOSING';
                cl += ' bg-warning text-dark';
                break;
            case 3:
                text = 'CLOSED';
                cl += ' bg-danger';
                break;
            default:
                break;
        }

        return (
            <span className={cl}>
                {text}
            </span>
        );
    }

    if (!props.OpenVpnStats) {
        return noDataDiv;
    }

    if (!props?.OpenVpnStats) {
        return noDataDiv;
    }

    if (!props?.OpenVpnStats?.client_list || !props?.OpenVpnStats?.routing_table) {
        return noDataDiv;
    }

    if (!props?.OpenVpnStats?.client_list?.length || !props?.OpenVpnStats?.routing_table?.length) {
        return noDataDiv;
    }

    getColumnsName();
    getTableHeader();
    const content = getContent();
    return (
        <div className="mx-3">
            <div className="container my-2">
                <div className="row justify-content-between">
                    <div className="col-auto me-auto align-self-center" ><h5>VPN status update: {props?.OpenVpnStats?.status}</h5></div>
                    <div className="col-auto align-self-center "><h5>Connection state: {socketState(props?.wsState)}</h5></div>
                </div>
            </div>
            <table className={tableClassName}>
                <thead><tr>{tableHeader}</tr></thead>
                <tbody>{content}</tbody>
            </table>
        </div>
    );
}